import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useQiyeTypeUpdateQuery, useQiyeTypeUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
import TradeSelect from '../trade/TradeSelect';
function FirmTypeEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useQiyeTypeUpdateQuery({qyt_id:props.qyt_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    qyt_hyt_name:data.Result.qyt_hyt_name,
                    qyt_name:data.Result.qyt_name,
                })
                setInfo(prevState=>({...prevState,
                    qyt_hyt_name:data.Result.qyt_hyt_name,
                    qyt_hyt_id:data.Result.qyt_hyt_id,
                    qyt_name:data.Result.qyt_name,          
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useQiyeTypeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改行业'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "qyt_hyt_id" : info.qyt_hyt_id,
                        "qyt_hyt_name" : info.qyt_hyt_name,
                        "qyt_id" : props.qyt_id,
                        "qyt_name" : info.qyt_name,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <TradeSelect
                        label='行业'      
                        name="qyt_hyt_name"                        
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,qyt_hyt_name:f,qyt_hyt_id:e}))
                        }}
                        style={{width:'200px'}}
                        required
                    />
                    <Form.Item name="qyt_name" wrapperCol={{span:10}} required label='企业类型'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,qyt_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    
                </Form>
            </Modal>
        </>
    )
}

export default FirmTypeEdit